import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { PersonOutlineOutlinedIcon, LinkOutlinedIcon, FilterAltOutlinedIcon, EmailOutlinedIcon, QrCodeOutlinedIcon, SettingsOutlinedIcon } from 'icons/materialIcons';

const TeamTemplateEditSidenav = ({ onMenuItemClick, selectedItem }) => {
    const listItemStyle = {
        padding: '4px 8px',
        whiteSpace: 'nowrap',
        minHeight: '40px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
    };

    const listItemTextStyle = {
        margin: 0,
        '& .MuiTypography-root': {
            fontSize: '0.8rem',
            fontWeight: 600,
            color: "#4f4f4f",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    };

    const iconStyle = {
        minWidth: '32px',
        marginRight: 0.5
    };

    return (
        <Box
            sx={{
                display: { xs: 'none', sm: 'block' },
                backgroundColor: '#fff',
                borderRadius: '8px 0 0 8px',
            }}
        >
            <Box sx={{ marginTop: 2 }}>
                <List sx={{ '& .MuiListItem-root': listItemStyle }}>
                    <ListItem onClick={() => onMenuItemClick('about')}>
                        <ListItemIcon sx={iconStyle}>
                            <PersonOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="About"
                            sx={listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem onClick={() => onMenuItemClick('links')}>
                        <ListItemIcon sx={iconStyle}>
                            <LinkOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Links"
                            sx={listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem onClick={() => onMenuItemClick('qrCode')}>
                        <ListItemIcon sx={iconStyle}>
                            <QrCodeOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="QR Code"
                            sx={listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem onClick={() => onMenuItemClick('leadCaptureForm')}>
                        <ListItemIcon sx={iconStyle}>
                            <FilterAltOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Lead Capture Form"
                            sx={listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem onClick={() => onMenuItemClick('followUpEmail')}>
                        <ListItemIcon sx={iconStyle}>
                            <EmailOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Follow Up Email"
                            sx={listItemTextStyle}
                        />
                    </ListItem>
                    <ListItem onClick={() => onMenuItemClick('settings')}>
                        <ListItemIcon sx={iconStyle}>
                            <SettingsOutlinedIcon sx={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Settings"
                            sx={listItemTextStyle}
                        />
                    </ListItem>
                </List>
            </Box>
        </Box>
    );
};

export default TeamTemplateEditSidenav;

